import React, { useState } from "react";
import {  Form, Button, Alert } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();

    // Optional: Check if passwords match
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      const res = await fetch(
        "https://ecom-api.applligentdemo.com/users/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, otp, newPassword, confirmPassword }),
        }
      );

      const data = await res.json();
      console.log("Status Code:", res.status);
      console.log("API response:", data);

      
      if (data.success) {
        console.log(" Success received from backend");
        setMessage(data.message || " Password reset successfully!");
        setTimeout(() => {
          console.log("Navigating to login...");
          navigate("/login");
        }, 1000);
      } else {
        console.log("Backend returned failure");
        setMessage(data.message || "Failed to reset password.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setMessage(" Server error. Please try again later.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2 className="text-center mb-4">Password Reset</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleReset}>
          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="email"
              value={email}
              //onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Form.Label>Email address</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="password"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <Form.Label>OTP</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Form.Label>Password</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <Form.Label>Confirm Password</Form.Label>
          </Form.Group>

          <Button
            variant="dark"
            type="submit"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Logging in...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          If You have account <a href="/login">login?</a>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
